import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { Input } from '@/ui'

interface UserSearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

// `UserSearchDropdown` is for exact suggestion-based user selection and returns
// a user ID. `UserSearchInput` is for free-text filtering and returns the raw
// query string so screens can search by name, email, or numeric user ID.
export const UserSearchInput = ({
  value,
  onChange,
  placeholder = 'Search by user name, email, or ID',
}: UserSearchInputProps) => {
  const hasValue = value.trim().length > 0

  return (
    <div className="w-full max-w-[480px]">
      <Input
        type="search"
        value={value}
        placeholder={placeholder}
        className="w-full"
        inputClassName="h-10"
        iconRight={hasValue ? faXmark : undefined}
        onIconRightClick={hasValue ? () => onChange('') : undefined}
        iconRightClassName={hasValue ? 'cursor-pointer' : undefined}
        onChange={(event) => onChange(event.target.value)}
        aria-label={placeholder}
      />
    </div>
  )
}
